export function checkDataType(parameter, value) {
    let parameterType = parameter.dataType;
    if (Array.isArray(parameter.values)) {
        parameterType = "value";
    }

    let valueType = (typeof value).replace("string", "text");
    if (
        parameter.values
        && parameter.values.some(
            (parameterValue) => parameterValue.id === value
        )
    ) {
        valueType = "value";
    }

    return [
        parameterType === valueType,
        parameterType,
        valueType,
    ];
}

export function getValueLabel(parameter, value) {
    return parameter?.values?.find?.(
        (parameterValue) => parameterValue.id === value
    )?.label?.[0]?.text;
}

export function parseValueInput(value) {
    if (["true", "false"].includes(value)) {
        return value === "true";
    } else if (parseFloat(value).toString() === value) {
        return parseFloat(value);
    } else {
        return value;
    }
}
